module.exports = __webpack_public_path__ + "static/img/cont1902.58dcc8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont1902.jpg
// module id = uVDZ
// module chunks = 0